import React, { Component } from 'react'
import './addstickbutton.scss'

class AddStickButton extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--addstickbutton', this.props.classes].join(' ')
		return (
			<div className={classes}>
				<button className="addStick-btn" onClick={this.props.click}>
					<span className="icon-icon-plus"></span>
					<p>{this.props.msg}</p>
				</button>
			</div>
		)
	}
}

export default AddStickButton
